import { Autocomplete, TextField, Typography } from '@mui/material';
import {
  ButtonSave,
  ButtonSaveTitleSmall,
  FormSettingBlock,
  FormSettingButtons,
  FormSettingStyledListItem,
} from './style';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface TimezoneProps {
  timezones: Array<string>;
  timezone: string;
  offset: string;
  setTimezone: (value: React.SetStateAction<string>) => void;
  onSave: () => Promise<boolean>;
}

const Timezone: React.FC<TimezoneProps> = ({
  timezones,
  timezone,
  offset,
  setTimezone,
  onSave,
}) => {
  return (
    <FormSettingButtons>
      <FormSettingBlock>
        <FormSettingStyledListItem>
          <Typography fontSize={'large'}>
            <FormattedMessage id="storeDetails.timezone.label" defaultMessage="Timezone" />
          </Typography>
          <Autocomplete
            disablePortal
            value={timezone}
            onChange={(_, newTimezone: string | null) => {
              setTimezone(newTimezone ?? '');
            }}
            id="combo-box-timezones"
            options={timezones}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} />}
          />
        </FormSettingStyledListItem>
        <FormSettingStyledListItem>
          <Typography fontSize={'large'}>
            <FormattedMessage id="storeDetails.timezone.offset.label" defaultMessage="Offset" />
          </Typography>
          <TextField
            sx={{ width: 300 }}
            aria-readonly={true}
            InputProps={{
              readOnly: true,
            }}
            value={offset ?? ''}
          />
        </FormSettingStyledListItem>
      </FormSettingBlock>
      <FormSettingBlock>
        <ButtonSaveTitleSmall>
          <ButtonSave onClick={onSave}>
            <FormattedMessage
              id="storeDetails.timezone.button.save.label"
              defaultMessage="Update"
            />
          </ButtonSave>
        </ButtonSaveTitleSmall>
      </FormSettingBlock>
    </FormSettingButtons>
  );
};

export default Timezone;
